import { useEffect, useState } from "react";
import { getAllRoles } from "api/admin/index";
import CreatableSelect from 'react-select/creatable';
import CreateRoleModal from "components/admin/CreateRoleModal";

const selectStyles = {
    control: (provided) => ({
        ...provided,
        cursor: "pointer",
        backgroundColor: "#0D1B2A",
        color: "white",
        border: "1px solid #382F5C",
        padding: "6px 12px 6px 2px",
        outline: "none",
        textAlign: "left",

        ":hover": {
            border: "1px solid #666699",
            outline: "none",
        },

        ":focus": {
            border: "1px solid #666699",
            outline: "none",
        },

        ":active": {
            border: "1px solid #666699",
            outline: "none",
        },

    }),
    menu: (provided) => ({
        ...provided,
        color: "white",
        borderRadius: 10,
        overflow: "hidden",
        boxShadow: "0px 0px 4px 0px #7357EB40",
        backgroundColor: "#0B1723",
    }),
    option: (baseStyles) => ({
        ...baseStyles,
        backgroundColor: "#0B1723",
        ":hover": {
            backgroundColor: "#132639",
        }
    }),
    singleValue: (baseStyles) => ({
        ...baseStyles,
        color: "white",
    }),
    multiValue: (baseStyles) => ({
        ...baseStyles,
        alignItems: "center",
        gap: "4px",
        backgroundColor: "#0D1B2A",
        color: "#ffffff",
        border: "1px solid #382F5C",
        borderRadius: "4px",
        padding: "6px",
    }),
    multiValueLabel: () => ({
        color: "#ffffff",
    }),
    multiValueRemove: () => ({}),
    input: (baseStyles) => ({
        ...baseStyles,
        color: "white",
    })
};


const UserRoleSelect = ({ onChange, selectedValue, disabled }) => {
    const [userRoles, setUserRoles] = useState([]);
    const [rolesLoading, setRolesLoading] = useState(false);
    const [createRoleModalOpen, setCreateRoleModalOpen] = useState(false);
    const [createRoleInitialName, setCreateRoleInitialName] = useState("");

    const fetchUserRoles = async () => {
        try {
            setRolesLoading(true);
            const response = await getAllRoles();
            const roles = (response?.data ?? []).map((role) => ({
                label: role.roleName,
                value: role._id,
            }));
            setUserRoles(roles);
        } catch (error) {
            console.error("Error fetching roles:", error);
        } finally {
            setRolesLoading(false);
        }
    };

    const handleOptionCreate = (inputValue) => {
        setCreateRoleInitialName(inputValue.trim() || "");
        setCreateRoleModalOpen(true);
    };

    const handleCreateRoleSuccess = (newRole) => {
        setUserRoles((prev) => {
            const exists = prev.some((r) => r.value === newRole.value);
            return exists ? prev : [...prev, newRole];
        });
        onChange(newRole);
        setCreateRoleModalOpen(false);
    };

    useEffect(() => {
        fetchUserRoles();
    }, []);

    return (
        <>
            <CreatableSelect
                isDisabled={rolesLoading || disabled}
                isLoading={rolesLoading}
                placeholder="Select User Role..."
                options={userRoles}
                value={selectedValue}
                onChange={(newValue) => onChange(newValue)}
                onCreateOption={handleOptionCreate}
                backspaceRemovesValue={false}
                components={{ IndicatorSeparator: null }}
                isClearable
                menuPosition="absolute"
                menuPlacement="auto"
                styles={selectStyles}
                tabSelectsValue={false}
            />
            <CreateRoleModal
                open={createRoleModalOpen}
                onClose={() => setCreateRoleModalOpen(false)}
                initialRoleName={createRoleInitialName}
                onSuccess={handleCreateRoleSuccess}
            />
        </>
    );
};

export default UserRoleSelect;
